import React from 'react'
import { Box, Typography } from '@mui/material'
import { AppleIcon } from '../Icons/AppleIcon'

type Promotion = {
  title: boolean
  description: string
  titleValue?: string
  footNote: string
  titleIcon?: JSX.Element
}

export const PromotionDetails: React.FC = () => {
  const promotions: Promotion[] = [
    {
      title: true,
      description: 'Cash back on eligible Health & Wellness purchases',
      titleValue: '5',
      footNote: '1'
    },
    {
      title: true,
      description: 'Cash back on eligible Grocery purchases',
      titleValue: '5',
      footNote: '1'
    },
    {
      title: true,
      description: 'Cash back on all other eligible purchases',
      titleValue: '3',
      footNote: '1'
    },
    {
      title: false,
      description: 'The latest Apple Watch',
      titleIcon: <AppleIcon sx={{ height: '1.4em', width: '4em' }} />,
      footNote: '2'
    }
  ]

  const PromotionBox: React.FC<{ promotion: Promotion }> = ({ promotion }) => (
    <Box sx={{ maxWidth: '8rem', minWidth: '7rem', pl: 2, mt: 2 }}>
      {promotion.title ? (
        <Typography component="div" variant="caption" sx={{ display: 'flex' }}>
          <div style={{ verticalAlign: 'top', paddingTop: 5 }}>Up to </div>
          <div style={{ fontSize: '1.5rem', fontWeight: '600', marginLeft: 5 }}>
            {promotion.titleValue}%
          </div>
        </Typography>
      ) : promotion.titleIcon ? (
        <div>{promotion.titleIcon}</div>
      ) : (
        <></>
      )}

      <Typography component="div" variant="caption" style={{ lineHeight: 1.3 }}>
        {promotion.description}
        {promotion.footNote && (
          <span style={{ verticalAlign: 'top', fontSize: '.5rem' }}>
            {promotion.footNote}
          </span>
        )}
      </Typography>
    </Box>
  )

  return (
    <div
      style={{
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'center'
      }}
    >
      {promotions.map((promotion, index) => (
        <div key={index}>
          <PromotionBox promotion={promotion} />
        </div>
      ))}
    </div>
  )
}
